<template>
    <div class="sustainable-component pot-transfer">
        <!--<div class="bg-success mb-3 p-3 rounded">vue component pot-transfer</div>-->
        <div class="container-fluid p-0">
            <div class="row my-3" v-if="transferred == true">
                <div class="col-12">
                    <v-alert type="success" title="Färdigt">
                        <div>
                            Potten har blivit överförd
                        </div>
                    </v-alert>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>Här kan du föra över de nya lönerna till det ordinarie verktyget.</p>
                    <p>Observera att du inte kan ångra överföringen efteråt. Du bör därför försäkra dig om att du fördelat alla pengar korrekt innan du startar överföringen.</p>
                    <p>Klicka på knappen Överför nedan för att starta överföringen.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <v-btn v-bind:disabled="disabled" variant="tonal" class="bg-primary" @click="transferPot">
                        Överför
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'pot-transfer',
        components: {
            CommonSpinner,
        },
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async transferPot()
            {
                if (confirm("Är du säker att du vill överföra potten?")) {
                    this.loading++;
                    try {
                        await WageService.transferPot();
                        this.transferred = true;
                        this.displaySnackBar("Potten har överförts");
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                transferred: false,
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            
        },
        mounted() {
           
            
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
